import PaddedSection from '../../atoms/PaddedSection/PaddedSection';
import React, { Component } from 'react';
import SectionHeading from '../../molecules/SectionHeading/SectionHeading';
import DownloadButton from '../../atoms/DownloadButton/DownloadButton';
import './styles.css';

/**
 * Description
 *
 * @typedef {Object} Props
 * @typedef {Object} content
 *
 * @augments {Component<Props>}
 */
export default class Samples extends Component {
	render () {
		const { heading, subHeading, scormSamples } =
			this.props.content.samples;
		return (
			<PaddedSection className='Samples'>
				<SectionHeading heading={heading} subheading={subHeading} />

				{scormSamples.map(({ id, title, downloadLink, iframeLink }) => (
					<section key={id} className={'iframeSection'}>
						<div className={'iframeHeadingWrap'}>
							<h2 className={'iframeHeading'}>{title}</h2>
							<div className={'iframeButtonWrapper'}>
								<DownloadButton
									className={'Button Button-link'}
									href={downloadLink}
									download={true}
									buttonLabel={'Download SCORM sample'}
								/>
							</div>
						</div>
						<div className='iframeContainer'>
							<iframe title={title} className='responsiveIframe' src={iframeLink} />
						</div>
					</section>
				))}
			</PaddedSection>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/templates/Samples/Samples.js